//import api from '../api';
import { newAPIPost } from '../api/index.js';

export default {
    state: {
        ccrLog: [],
        searchRequest: null,
      },

      mutations: {
        updateCCRLog(state, list) {
          state.ccrLog = list;
        },
        updateSearchCCRLogRequest(state, searchRequest) {
          state.searchRequest = searchRequest;
        },
      },


      actions: {
        async ccrLog({ commit, state }, request) {
          const fallbackRequest = request || state.searchRequest;
          const requestToSend = JSON.parse(JSON.stringify(fallbackRequest))
          console.log(requestToSend);
          const st = performance.now();
          //const result = await api.post('/api/w/ccr/data/getCCRLog', requestToSend);
          const result = await newAPIPost('/api/w/ccr/data/getCCRLog', requestToSend);
          //const result = await api.post('/api/w/gstMasterData/driverMasterData', drivers = null, transYard = null, defaultSalesOffice = "LGB");
          commit('updateSearchCCRLogRequest', fallbackRequest);
          console.log(JSON.stringify(result));
          return commit('updateCCRLog', result);
                },
      },

      getters: {
        getCCRLog: state => state.ccrLog,
      },
}